import { auth } from "../config/firebase";
import HttpService from "./httpService";

export class AuthService {
    static googleLogin = async ({ token }: { token: string }) => {
        return HttpService.post<any>("/login",{token});
    }

    static reFreshToken = async () => {
        await auth.currentUser?.getIdToken(true)
    }

    static logout = async () => {
        try {
            await auth.signOut();
        } catch (error) {
            throw error;
        }
    }

    static getIdToken = async (retryCount = 0, maxRetries = 3): Promise<string> => {
        // Wait for Firebase Auth to initialize
        if (!auth.currentUser) {
            if (retryCount >= maxRetries) {
                throw new Error('Authentication timeout - please try again');
            }

            // Wait for 1 second before retrying
            await new Promise(resolve => setTimeout(resolve, 1000));
            return this.getIdToken(retryCount + 1, maxRetries);
        }

        try {
            const tokenResult = await auth.currentUser.getIdTokenResult();
            const expirationTime = tokenResult.expirationTime ? new Date(tokenResult.expirationTime).getTime() : 0;
            const currentTime = new Date().getTime();

            if (currentTime >= expirationTime) {
                await auth.currentUser.getIdToken(true);
            }

            const token = await auth.currentUser.getIdToken();
            if (!token) {
                throw new Error('Failed to get valid token');
            }
            return token;
        } catch (error) {
            console.error('Error getting ID token:', error);
            throw error;
        }
    }
}
